<template>
    <b-modal size="sm" @hidden="clear" v-model="show" id="SendTestEmailModal" centered hide-footer :title="$t('settings.general.email.confirm.modal.title')">
      <b-form class="share-invoice-form">
        <b-form-group :label="$t('settings.general.email.confirm.modal.description')" label-for="EmailInput">
          <b-form-input class="input-info-field" type="email" v-model="emailVal"
            :value="emailVal" :state="validEmail" :placeholder="'guest@domain.com'"/>
        </b-form-group>
        <b-tooltip v-if="!validEmail" target="send-email-button-container" placement="top" :title="$t('settings.general.email.confirm.modal.tooltip')"/>
        <span id="send-email-button-container">
          <b-button @click="sendInvoiceEmail" :disabled="!validEmail" size="md" variant="outline-primary">
            {{$t('settings.general.email.confirm.modal.send_button')}}
          </b-button>
        </span>
      </b-form>
    </b-modal>
</template>

<script>
  import { mapActions } from "vuex";
  export default {
    name: "SendTestEmailModal",
    components: {
    },
    props: {
      email: {
        type: String,
        required: false,
        default: ''
      },
    },
    data() {
      return {
        emailVal: this.email,
        show: false,
        fieldState: {
          emailVal: true
        }
      }
    },
    methods: {
      clear() {
        this.emailVal = '';
      },
      hide() {
        this.show = false;
      },
      open() {
        this.show = true;
      },
      async sendInvoiceEmail() {
        if (!this.validEmail) {
          this.errorNotification('Invalid email.')
          return
        }
        try {
          this.$Progress.start();
          await this.sendInvoice({email: this.emailVal})
          this.successNotification("Email Sent.")
          this.hide()
        } catch (e) {
          this.errorNotification(`Sending email failed: ${e}`)
          this.$Progress.finish();
        }
      },
      ...mapActions([
        //"sendInvoice" this needs to be replaced
      ])
    },
    computed: {
      validEmail() {
        const re = /\S+@\S+\.\S+/;
        return re.test(this.emailVal);
      }
    }
  };
</script>

<style lang="scss">
  #SendTestEmailModal.modal-dialog-centered {
      min-width: 800px;
      .modal-header {
        height: initial;
        width: initial;
      }
      .modal-open {
        margin: auto;
      }
  }
</style>